import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, Events } from 'ionic-angular';
import { HttpClient } from '../../../services/HttpClient';

import { UserPage } from './user/user';
import { AddUserPage } from './addUser/addUser';

@Component({
  selector: 'page-users',
  templateUrl: 'users.html',
  providers : [HttpClient]
})
export class UsersPage {

	users;

  modalCtrl : ModalController;
	
  httpClient : HttpClient;
  searchQuery = '';

  	constructor(public navCtrl: NavController, public navParams: NavParams, httpClient : HttpClient,modalCtrl : ModalController, events : Events) {
  		this.modalCtrl = modalCtrl;
      this.httpClient = httpClient;
      this.httpCallUsers('',1000);
      events.subscribe('user:delete',()=>{
        this.httpCallUsers('',1000);
      }); 
  	}
  
  	httpCallUsers(name,max){
      let user;
      this.httpClient.get('/users/me',(error,data)=>{
        user = data.json();
        if(user.role == 5) {
          this.httpClient.get('/users?name='+name+'&max='+max+'&role=2',(error,data)=>{
            this.users = data.json();
          });
        } else {
          this.httpClient.get('/users?name='+name+'&max='+max,(error,data)=>{
            this.users = data.json();
          });
        }
      });
  	}

    onSearch(){
      if(this.searchQuery.length > 0){
        this.httpCallUsers(this.searchQuery,50);
      }else{
        this.httpCallUsers(this.searchQuery,1000);
      }
    }

    onClickUser(user){
      this.navCtrl.push(UserPage, {id : user.id});
    }

    onClickAdd(){
      let modal = this.modalCtrl.create(AddUserPage);
      modal.present();

      modal.onDidDismiss(reload =>{
        if(reload){
          this.httpCallUsers('',1000);
        }
      });
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/users/users.ts